/* unplugin-vue-components disabled */import { render } from "./StereoSameEdgeRender.vue?vue&type=template&id=015ea7d2&scoped=true"
import script from "./StereoSameEdgeRender.vue?vue&type=script&lang=js"
export * from "./StereoSameEdgeRender.vue?vue&type=script&lang=js"

import "./StereoSameEdgeRender.vue?vue&type=style&index=0&id=015ea7d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015ea7d2"]])

export default __exports__